import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type TextAlignType, type TextAlignBreakpointType, textAlignList } from '../../typings/textAlignType';
import { BreakpointDepended } from '../breakpointDepended';

export function withTextAlignProps(defaultValue?: TextAlignType | TextAlignBreakpointType) {
  return {
    /**
     * Justowanie tekstu
     */
    textAlign: {
      type: [String, Object] as PropType<TextAlignType | TextAlignBreakpointType>,
      default: defaultValue
    }
  };
}

/**
 * Zwraca klasy justowania tekstu
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withSizeProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useTextAlignProps = (props: ExtractPropTypes<ReturnType<typeof withTextAlignProps>>) => {
  return computed(() => {
    if (typeof props.textAlign === 'string') {
      return `text-${props.textAlign}`;
    }
    if (BreakpointDepended(props.textAlign).value) {
      return `text-${BreakpointDepended(props.textAlign).value}`;
    }
    return;
  });
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesTextAlignArgs = {
  args: {
    textAlign: undefined
  },

  argTypes: {
    textAlign: {
      options: textAlignList,
      control: { type: 'select' }
    }
  }
};
